import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { MdHighlightOff } from 'react-icons/md';
import { theme } from 'utils/style/theme';
const ValidationCard = (props) => {
  const { validationData, setValidationShow, validationShow } = props;
  const [close, setClose] = useState(validationShow);

  useEffect(() => {
    setClose(validationShow);
  }, [validationShow]);
  return (
    <Container validationData={validationData} close={close}>
      {validationData && (
        <CloseButton onClick={() => setValidationShow(false)}>
          <MdHighlightOff size={25} color={'#747576'} />
        </CloseButton>
      )}
      <h3>스크립트 에러</h3>
      <ol>
        {validationShow &&
          validationData.map((v, i) => (
            <li key={i}>
              <span>{v.rownum}행</span> - {v.validation}
            </li>
          ))}
      </ol>
    </Container>
  );
};

export default ValidationCard;

const Container = styled.section`
  margin: 5px 10px;
  background-color: ${theme.colors.script_side_back};
  /* background-color: yellow; */
  /* width: 99vw; */
  /*   max-height: 25vh;*/
  height: ${(props) =>
    props.validationData && props.validationData.length !== 0 && '22vh'};
  display: ${(props) =>
    props.validationData.length === 0 || props.close === false
      ? 'none'
      : 'block'};
  padding-top: 12px;
  overflow-y: auto;
  border-radius: 8px;
  border: 1px solid ${theme.colors.script_blue};
  width: 98%;
  position: fixed;
  z-index: 2;
  bottom: 0;

  &::-webkit-scrollbar {
    width: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #2f3542;
  }
  &::-webkit-scrollbar-track {
    background-color: grey;
  }

  h3 {
    margin-left: 20px;
    font-weight: bold;
    font-size: 16px;
    margin-bottom: 10px;
  }
  ol {
    margin-left: 7px;
    list-style: none;
    overflow: auto;
    counter-reset: li;
  }
  li::before {
    content: counter(li) '. ';
    color: #6b6b6b;
    margin-right: 10px;
    font-weight: bold;
    /* 숫자를 우측 정렬로 하면, '.'가 숫자 앞으로 오게된다.
    // 번호 우측 정렬
    display: inline-block;
    width: 1em;
    margin-left: -1.5em;
    margin-right: 1em;
    text-align: right;
    direction: rtl;
    */
  }
  li {
    margin-left: -16px;
    counter-increment: li;
    line-height: 24px;
    display: block;
    font-size: 14px;
  }
  span {
    color: red;
  }
`;

const CloseButton = styled.button`
  position: absolute;
  right: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: none;
  cursor: pointer;
  // 클릭했을 때 생기는 테두리를 없애준다.
  &:focus {
    border: none;
    outline: none;
    fill: red;
  }
  &:hover {
    background-color: none;
    fill: blue;
  }
  &:active {
    // background-color: yellow;
    border: none;
    -webkit-filter: drop-shadow(2px 2px 2px rgba(0, 0, 0, 0.3));
    filter: drop-shadow(2px 2px 2px rgba(0, 0, 0, 0.3));
  }
`;
